import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CardContent, CardHeader, Grid } from '@material-ui/core';
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useStyles } from './DialogEditTelefoneStyles';
import InputMask from 'react-input-mask';
import { ServiceValues } from '../../../src/values/ServiceValues';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { TiposTelefoneValues } from '../../../src/values/TipoTelefonesValues';
import MenuItem from '@material-ui/core/MenuItem';
import UsuarioRegisterEmpresas
  from '../../views/UsuarioRegister/components/UsuarioRegisterEmpresas/UsuarioRegisterEmpresas';


const timeout = ServiceValues.timeout;

function DialogEditTelefone(props) {
  const {
    usuario,
    setUsuario,
    open,
    setOpen,
    index_telefone,
    setIndex_telefone,
    edicao,
    showMessageSnack,
    setShowMessageSnack,
    messageSnack,
    setMessageSnack,
    typeSnack,
    setTypeSnack,
  } = props;
  const [codigoPais, setCodigoPais] = useState('+55');
  const [ddd, setDdd] = useState('');
  const [numeroTelefone, setNumeroTelefone] = useState('');
  const [maskDDD, setMaskDDD] = useState('(99)');
  const [maskTelCel, setMaskTelCel] = useState('9.9999-9999');
  const [tipoTelefone, setTipoTelefone] = useState();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));


  useEffect(() => {
    async function carregarUsuario() {
      if(edicao && index_telefone >= 0 && index_telefone < usuario.telefones.length){
        setDdd(usuario.telefones[index_telefone].ddd);
        setNumeroTelefone(usuario.telefones[index_telefone].telefone);
        setTipoTelefone(usuario.telefones[index_telefone].telefoneFixo);
      }
    }
    carregarUsuario();
  }, [index_telefone]);

  function saveTelefone() {
    if(!ddd || !numeroTelefone || tipoTelefone === undefined){
      setMessageSnack('Informe todos os campos.');
      setTypeSnack('warning');
      setShowMessageSnack(true);
    }
    else{
      const novoTelefone = {
        idTelefone: usuario.telefones[index_telefone].idTelefone,
        codigo_pais: codigoPais,
        ddd: ddd,
        telefone: numeroTelefone,
        tipo_telefone: tipoTelefone,
        telefoneFixo: tipoTelefone
      };
      if(edicao){
        usuario.telefones[index_telefone] = novoTelefone;
      }
      else{
        usuario.telefones.push(novoTelefone);
      }
      setUsuario(usuario);
      setDdd('');
      setNumeroTelefone('');
      setTipoTelefone('');
      setIndex_telefone(-1);
      setOpen(false);
    }

  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        maxWidth={'md'}
        fullWidth
      >
        <DialogContent>
          <ValidatorForm
            autoComplete="off"
          >

            <CardHeader
              subheader="Informe os seguintes dados para adicionar um telefone"
              title="Telefone"
            />
            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={2}
                  xs={12}
                >
                  <InputMask
                    mask={maskDDD}
                    value={ddd}
                    onChange={e => setDdd(e.target.value.replace('(', '').replace(')', ''))}
                  >
                    {
                      (inputProps) =>
                        <TextValidator
                          fullWidth
                          label="DDD"
                          helperText="Insira o DDD."
                          margin="dense"
                          name="ddd"
                          onChange={inputProps.onChange}
                          variant="outlined"
                          validators={['required']}
                          errorMessages={['Informe o DDD!']}
                        />
                    }
                  </InputMask>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={12}
                >
                  <InputMask
                    mask={maskTelCel}
                    value={numeroTelefone}
                    onChange={e => setNumeroTelefone(e.target.value.replace('.', '').replace('-', ''))}
                  >
                    {
                      (inputProps) =>
                        <TextValidator
                          fullWidth
                          label="Número"
                          helperText="Insira a número do telefone."
                          margin="dense"
                          name="telefone"
                          onChange={inputProps.onChange}
                          variant="outlined"
                          validators={['required']}
                          errorMessages={['Informe o número do numeroTelefone!']}
                        />
                    }
                  </InputMask>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={12}
                >
                  <SelectValidator
                    fullWidth
                    helperText="Insira o tipo de telefone!"
                    label="Tipo de Telefone"
                    margin="dense"
                    name="id_sistema"
                    onChange={e => setTipoTelefone(e.target.value)}
                    value={tipoTelefone}
                    variant="outlined"
                    validators={['required']}
                    errorMessages={['Insira o tipo de telefone!']}
                  >
                    {TiposTelefoneValues.map((tipo, index) => (
                      <MenuItem key={index} value={tipo.telefone_fixo}>{tipo.label}</MenuItem>
                    ))}

                  </SelectValidator>
                </Grid>
              </Grid>
            </CardContent>
            <DialogActions>
              <Button
                color="primary"
                onClick={saveTelefone}
                variant="contained"
              >
                Salvar
              </Button>
            </DialogActions>
          </ValidatorForm>
        </DialogContent>

      </Dialog>

    </div>

  );
};

DialogEditTelefone.propTypes = {
  className: PropTypes.string,
  usuario: PropTypes.object.isRequired,
};

export default DialogEditTelefone;


